import React, { useContext, useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import DayClosureSummariesTable from "components/Tables/DayClosureSummariesTable";
import ExportToPDFButton from "views/Components/ExportToPDFButton";
import StoreContext from "contexts/StoreContext";
import { notificationService } from "service/NotificationService";
import { apiService } from "service/ApiService";
import { ClipLoader } from "react-spinners";
import { transpileModule } from "typescript";

import { useTranslation } from "react-i18next";

export default function DayClosureSummariesModal({ dayClosureId, openModal, closeModal }) {
  const {
    t,
  } = useTranslation();

  const { storeId, setStoreId } = useContext(StoreContext);
  const [show, setShow] = useState(false);
  let [dayClosureData, setDayClosureData] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [showLoader, setShowLoader] = useState(true);
  const tableRef = useRef();

  function exportToPDF(ref) {
    if (!ref.current) return;

    html2canvas(ref.current, { scale: 2 }).then((canvas) => {
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      const pdfWidth = 210;
      const pdfHeight = (canvasHeight * pdfWidth) / canvasWidth;

      const pdf = new jsPDF("p", "mm", [pdfWidth, pdfHeight]);
      const imgData = canvas.toDataURL("image/png");

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`summaries_${dayClosureId}_${+Date.now()}.pdf`);
    });
  }

  const fetchDayClosureData = async () => {
    try {
      setShow(true);
      setShowLoader(true);
      const dataResponse = await apiService.get(`api/v1/day-closures/${dayClosureId}/store/${storeId}/summaries`);
      setDayClosureData(dataResponse);
      setFromDate(dataResponse.fromDate);
      setToDate(dataResponse.toDate);
      setShowLoader(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
    }
  };

  useEffect(() => {
    if (openModal === 0) return;
    fetchDayClosureData();
  }, [openModal]);

  const handleClose = () => {
    setShow(false);
    closeModal();
  };

  return (
    <>
      <Modal size="md" dialogClassName="my-modal" show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title as="h5">{t("common.labels.cashClosureSuffix") + dayClosureId}</Modal.Title>
        </Modal.Header>
        {showLoader ? (
          <div style={{ textAlign: "center", marginTop: "5vh" }}>
            <ClipLoader size={50} color={"#ff6fbc"} />
          </div>
        ) : (
          <>
            <Modal.Body>
              <div style={{ textAlign: "center", fontWeight: "bold", textDecoration: "underline" }}>
                <h5>{`${fromDate} - ${toDate}`}</h5>
              </div>
              <DayClosureSummariesTable dayClosureData={dayClosureData} ref={tableRef} />
            </Modal.Body>
            <Modal.Footer>
              <ExportToPDFButton handler={() => exportToPDF(tableRef)} />
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
}
